import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { Button, Col, Divider, Form, Modal, Row, Space } from 'antd';

import CustomCheckbox from '../../components/CustomCheckbox/CustomCheckbox';
import './style.scss';

const ModalFilterClients = ({
  filter,
  setFilter,
  openFilter,
  handleCloseFilter,
}) => {
  const [form] = Form.useForm();
  const { t } = useTranslation('');

  const initVAlue = {
    type: { ALL: true, PERSON: false, ORGANIZATION: false },
    status: { ALL: true, PENDING: false, DONE: false, NONE: false },
  };

  useEffect(() => {
    if (filter) {
      form.setFieldsValue(filter);
      setFilterState(filter);
    } else {
      form.setFieldsValue(initVAlue);
      setFilterState(initVAlue);
    }
  }, [openFilter]);

  const [filterState, setFilterState] = useState(initVAlue);
  // PENDING, DONE, NONE

  const accountType = [
    { id: 1, label: 'ALL' },
    { id: 2, label: 'PERSON' },
    { id: 3, label: 'ORGANIZATION' },
  ];

  const statusList = [
    { id: 1, label: 'ALL' },
    { id: 2, label: 'PENDING' },
    { id: 3, label: 'DONE' },
    { id: 4, label: 'NONE' },
  ];

  const handleRest = () => {
    setFilterState(initVAlue);
    setFilter(null);
  };

  const handleCancel = () => {
    handleCloseFilter();
  };

  const handleFilterChange = (groupName, changedValue, isChecked) => {
    setFilterState((prevState) => {
      let groupValues = { ...prevState[groupName] };

      if (changedValue === 'ALL' && isChecked) {
        Object.keys(groupValues).forEach((key) => {
          groupValues[key] = key === 'ALL';
        });
      } else if (changedValue !== 'ALL' && isChecked) {
        groupValues[changedValue] = true;
        if (groupValues['ALL']) {
          groupValues['ALL'] = false;
        }

        const otherKeys = Object.keys(groupValues).filter(
          (key) => key !== 'ALL',
        );
        const allOthersChecked = otherKeys.every((key) => groupValues[key]);

        if (allOthersChecked) {
          Object.keys(groupValues).forEach((key) => {
            groupValues[key] = key === 'ALL';
          });
        }
      } else if (!isChecked) {
        groupValues[changedValue] = false;

        if (changedValue !== 'ALL') {
          const otherKeys = Object.keys(groupValues).filter(
            (key) => key !== 'ALL',
          );
          const allOthersChecked = otherKeys.every((key) => groupValues[key]);

          if (allOthersChecked) {
            Object.keys(groupValues).forEach((key) => {
              groupValues[key] = key === 'ALL';
            });
          }
        }
      }

      const hasAnyChecked = Object.values(groupValues).some((val) => val);
      if (!hasAnyChecked) {
        groupValues['ALL'] = true;
      }

      return {
        ...prevState,
        [groupName]: groupValues,
      };
    });
  };

  const onSubmit = () => {
    setFilter(filterState);
    handleCloseFilter();
  };

  return (
    <Modal
      width={408}
      className="filter-modal"
      centered
      open={openFilter}
      onCancel={handleCancel}
      footer={false}
      zIndex={1500}
    >
      <Form
        form={form}
        name="filter-config"
        layout="vertical"
        onFinish={onSubmit}
      >
        <div>
          <Row className="profile-data-row">
            <Col>
              <div className='filter-group-title'>{t('ROLE_HEADER')}</div>
              <Space direction="horizontal">
                {accountType.map((i) => (
                  <CustomCheckbox
                    key={i.id}
                    checked={filterState.type[i.label] || false}
                    onChange={(e) =>
                      handleFilterChange('type', i.label, e.target.checked)
                    }
                  >
                    {t(i.label)}
                  </CustomCheckbox>
                ))}
              </Space>
            </Col>
          </Row>
          <Divider className="filter-divider" />
          <Row className="profile-data-row">
            <Col>
              <div  className='filter-group-title'>{t('STATUS')}</div>
              <Space direction="horizontal">
                {statusList.map((i) => (
                  <CustomCheckbox
                    key={i.id}
                    checked={filterState.status[i.label] || false}
                    onChange={(e) =>
                      handleFilterChange('status', i.label, e.target.checked)
                    }
                  >
                    {t(i.label)}
                  </CustomCheckbox>
                ))}
              </Space>
            </Col>
          </Row>
          <Divider className="filter-divider" />

          <Row className="modal-newportfolio-button-wrapper">
            <Button
              type="text"
              className="modal-action-btn cancel-btn"
              onClick={handleRest}
            >
              {t('RESET')}
            </Button>
            <Button
              type="default"
              className="modal-action-btn save-btn"
              onClick={onSubmit}
            >
              {t('APPLY')}
            </Button>
          </Row>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalFilterClients;

ModalFilterClients.propTypes = {
  filter: PropTypes.object,
  openFilter: PropTypes.bool,
  handleCloseFilter: PropTypes.func,
  setFilter: PropTypes.func,
};
